import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

interface PlanningVueLoaderProps {
  isOpen: boolean;
  savingState: number;
}

const PlanningVueLoader: React.FC<PlanningVueLoaderProps> = ({
  isOpen,
  savingState,
}) => {
  return (
    <>
      {isOpen && (
        <Backdrop
          open
          sx={{
            zIndex: 2000,
            color: '#fff',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          <CircularProgress color="inherit" />
          <div style={{ marginTop: 8 }}>
            {savingState === 1
              ? 'Sauvegarde en cours…'
              : 'Chargement des données…'}
          </div>
        </Backdrop>
      )}
    </>
  );
};

export default PlanningVueLoader;
